export default __webpack_public_path__ + "static/media/full_11.09a816b7.jpg";